<template>
    <div class="flex flex-col gap-1">
        <label v-if="label" class="text-xs text-slate-500 dark:text-slate-400">{{ label }}</label>
        <Select
            v-model="value"
            :disabled="disabled"
            :editable="editable"
            :invalid="!!errorMessage"
            :option-label="optionLabel ?? 'label'"
            :option-value="optionValue ?? 'value'"
            :options="options"
            :placeholder="placeholder ?? label"
            :show-clear="showClear"
            fluid
        />
        <small v-if="errorMessage" class="text-red-400">{{ errorMessage }}</small>
    </div>
</template>

<script lang="ts" setup>
    import { Select } from 'primevue'
    import { useField } from 'vee-validate'
    import { toRef } from 'vue'

    const props = defineProps<{
        modelValue?:  string | null
        label?:       string
        rules?:       string
        disabled?:    boolean
        options:      unknown[]
        optionLabel?: string
        optionValue?: string
        showClear?:   boolean
        editable?:    boolean
        placeholder?: string
        name?:        string
    }>()

    const { value, errorMessage } = useField<string | null>(
        toRef(() => props.name ?? props.label ?? 'field'),
        props.rules,
        { syncVModel: true, controlled: true },
    )
</script>
